module.exports = __webpack_public_path__ + "img/cns_email_mac3.ce351d4a.png";